
import ChangeLog from '@/components/Onboarding/ChangeLog.vue'

export default {
    components: { ChangeLog },
    layout: 'changelogs',
    auth: false,
    async asyncData ({ $axios }) {
        const changeLogs = await $axios.$get('/v1/changelogs')

        return { changeLogs }
    },
    data () {
        return {
            changeLogs: []
        }
    },
    head () {
        return {
            'title': this.$t('سجل التحديثات')
        }
    }
}
